<template>
  <div>
    <nav-header  />
  <div class="shadow-sm container bg-white">

    <!-- 背景图部分 -->
    <div class="banner">
      <img :src="profile.bgImg" class="banner-img" />
      <div class="edit-banner" v-if="showEditImg">
        <el-upload
          ref="bannerUpload"
          class="banner-uploader"
          :action="action"
          :show-file-list="false"
          :on-success="onBannerSuccess"
          :before-upload="beforeBannerUpload"
          :auto-upload="true"
        >
          <div class="upload-trigger">
            <i class="el-icon-camera"></i>
            <span>更换背景</span>
          </div>
        </el-upload>
      </div>
    </div>

    <!-- 个人信息部分 -->
    <div class="user-info">
      <div class="avatar-container">
        <el-avatar 
          :size="100" 
          :src="userInfo.headImage || defaultAvatar"
          @click="handleChangeAvatar"
        ></el-avatar>
      </div>
      
      <div class="info-content">
        <h2 class="nickname">{{ userInfo.nickName || '未设置昵称' }}
        </h2>
        <p class="bio">{{ userInfo.signature || '这个人很懒，什么都没写~' }}</p>
      </div>
    </div>

    <!-- 在作品展示前添加圈子信息部分 -->
    <div class="circles-section" v-if="circles.length">
      <div class="section-header">
        <h3>圈子</h3>
        <small class="text-muted">共 {{ circles.length }} 个圈子</small>
      </div>
      
      <div class="circles-list">
        <div 
          class="circle-card" 
          v-for="circle in circles" 
          :key="circle.id"
          @click="navigateToCircle(circle.id)"
        >
          <div class="circle-avatar">
            <el-avatar :size="70" :src="circle.avatar"></el-avatar>
            <div class="circle-role" :class="{'admin': circle.role === 2}" v-if="circle.role === 1 || circle.role === 2">
              {{circle.role === 1 ? '圈主' : '管理员'}}
            </div>
          </div>
          <div class="circle-info">
            <h4 class="circle-name" :title="circle.name">{{ circle.name }}</h4>
            <div class="circle-stats">
              <span><i class="el-icon-user"></i>{{ circle.memberCount }}成员</span>
              <span><i class="el-icon-document"></i>{{ circle.postCount }}帖子</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 作品展示部分 -->
    <div v-if="works.length>=1" class="other-works">
      <div class="section-header">
        <h3>作品</h3>
        <small class="text-muted">共 {{ works.length }} 个作品</small>
      </div>
      
      <div class="works-grid">
        <div class="work-card" v-for="(item) in works" :key="item.id">
          <router-link :to="'/creation/'+item.id" class="work-link">
            <div class="work-cover">
              <img :src="item.cover" :alt="item.title"/>
              <div class="work-price">￥{{ item.amt }}</div>
            </div>
            <div class="work-content">
              <h4 class="work-title" :title="item.title">{{ item.title }}</h4>
              <div class="work-meta">
                <span class="views">
                  <i class="el-icon-view"></i> {{ item.views || 0 }}
                </span>
                <span class="likes">
                  <i class="el-icon-star-off"></i> {{ item.likes || 0 }}
                </span>
                <span class="name" :title="item.title">
                  <i class="el-icon-user"></i> {{ item.title || '未知作者' }}
                </span>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
    <UserInfo  ref="user"></UserInfo>
  </div>
</template>

<script>
import NavHeader from "@/components/layout/NavHeader.vue";
import UserInfo from "@/components/common/UserInfo.vue";

export default {
  name: 'UserProfile',
  components: {UserInfo, NavHeader},
  data() {
    return {
      action: process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
      defaultAvatar: '',
      defaultBanner: '',
      activeTab: 'all',
      pos: {
        x: '40%',
        y: '40%',
      },
      userInfo: {
        nickname: '示例用户',
        avatarUrl: '',
        bannerUrl: '',
        bio: '这是一段个人简介'
      },
      showUser:false,
      profile:{
        bgImg:'',
        introduce:''
      },
      works: [
        {
          id: 1,
          title: '作品标题',
          description: '作品描述',
          coverUrl: 'https://example.com/cover1.jpg'
        }
        // 更多作品...
      ],
      circles: []
    }
  },
  computed:{
    showEditImg() {
      console.log(this.userInfo.id)
      console.log(this.userStore.userInfo)
      return this.userInfo.id==this.userStore.userInfo.id
    }
  },
  mounted() {
    this.loadUserInfo(this.$route.params.id)
    this.fetchWorks();
    this.fetchUserInfo();
    this.fetchUserCircles();
  },
  methods: {
    showChat(){
      if(!this.userStore.userInfo)
      {
        window.$showLogin({
          success: () => {
            console.log("登录成功")
          },
          cancel: () =>{
            console.log("登录cancel")
          }
        });
        return
      }
      let left = this.$elm.fixLeft(this.$refs.item);
      let top = this.$elm.fixTop(this.$refs.item);
      let pos = {
        x: left + 50,
        y: top
      };
      this.$refs.user.open(this.userInfo,pos)
    },
    loadUserInfo(userId) {
      this.$http2({
        url: `/im/user/${userId}`,
        method: 'get'
      }).then((user) => {
        this.userInfo = user.data;
      })
    },
    handleChangeAvatar() {
      // 处理更换头像的逻辑
    },
    handleChangeBanner() {
      // 触发上传组件的点击事件
      this.$refs.bannerUpload.$el.querySelector('input').click()
    },

    // 上传前校验
    beforeBannerUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        this.$message.error('只能上传图片文件!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 5MB!')
        return false
      }
      return true
    },

    // 上传成功回调
    async onBannerSuccess(res) {
      console.log(res)
      if (res.code === 200) {
        try {
          // 调用接口更新用户横幅

          this.$http2({
            url: `/klgeek/profile`,
            method: 'put',
            data:{ bgImg: res.data.originUrl}
          })
          this.profile.bgImg = res.data.originUrl
        } catch (error) {
          console.error('更新封面失败:', error)
          this.$message.error('更新失败，请重试')
        }
      } else {
        this.$message.error(res.msg || '上传失败')
      }
    },
    async fetchUserInfo() {
      // 获取用户信息的接口调用
      this.$http2({
        url: `/klgeek/profile/detail/`+this.$route.params.id,
        method: 'get'
      }).then((res)=>{
        if(res.data)
        this.profile=res.data;
      })
    },
     fetchWorks() {
      // 获取用户作品列表的接口调用
      this.$http2({
        method: 'get',
        url: `/creation/explore?createBy=${this.$route.params.id}`
      }).then((res) => {
        this.works=res.rows
        console.log(this.works)
      }).catch(function (error) {
        console.log(error)
      })
    },
    // 加载用户的圈子信息
    async fetchUserCircles() {
      try {
        const res = await this.$http2({
          url: `/klgeek/circle/list`,
          params: {
            createBy: this.$route.params.id,
          },
          method: 'get'
        })
        this.circles = res.rows
      } catch(e) {
        console.error(e)
      }
    },
    // 跳转到圈子详情
    navigateToCircle(circleId) {
      this.$router.push(`/post-list/${circleId}`)
    }
  },
  created() {
    this.fetchUserInfo()
    this.fetchWorks()
  }
}
</script>

<style lang="scss" scoped>
@import 'https://www.klgeek.com/css/bootstrap.min.css';


.banner {
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.edit-banner {
  position: absolute;
  right: 20px;
  bottom: 20px;
  z-index: 2;
  
  .banner-uploader {
    display: block;
    
    .upload-trigger {
      display: flex;
      align-items: center;
      padding: 8px 16px;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      color: #fff;
      
      &:hover {
        background: rgba(0, 0, 0, 0.8);
      }
      
      i {
        font-size: 16px;
        margin-right: 6px;
      }
      
      span {
        font-size: 14px;
      }
    }
  }
}

// 确保上传组件可见
::v-deep .el-upload {
  display: block;
  cursor: pointer;
}

::v-deep .el-upload-dragger {
  width: auto;
  height: auto;
  border: none;
  background: none;
}

.user-info {
  margin-top: -50px;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.avatar-container {
  position: relative;
  display: inline-block;
}

.edit-avatar {
  position: absolute;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 4px;
  border-radius: 50%;
  cursor: pointer;
}

.info-content {
  margin-top: 20px;
}

.nickname {
  font-size: 24px;
  margin: 0;
}

.bio {
  color: #666;
  margin: 10px 0;
}

.works-section {
  padding: 20px;
  margin-top: 20px;
}

.section-title {
  font-size: 20px;
  margin-bottom: 20px;
}

.works-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
}

.work-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.work-link {
  display: block;
  text-decoration: none;
  color: inherit;
}

.work-cover {
  position: relative;
  padding-top: 66%;
  overflow: hidden;
}

.work-cover img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.work-cover .work-price {
  position: absolute;
  right: 12px;
  bottom: 12px;
  background: rgba(255, 107, 0, 0.9);
  color: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
}

.work-content {
  padding: 16px;
  background: #fff;
}

.work-title {
  margin: 0 0 8px;
  font-size: 15px;
  font-weight: normal;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.work-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #999;
  font-size: 13px;
}

.work-meta span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.work-meta i {
  font-size: 16px;
}

@media screen and (max-width: 768px) {
  .works-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  .work-content {
    padding: 12px;
  }
  
  .work-title {
    font-size: 14px;
  }
  
  .work-meta {
    font-size: 12px;
  }
}

.other-works {
  margin: 30px 0;
}

.other-works .section-header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin-bottom: 24px;
}

.other-works .section-header h3 {
  font-size: 20px;
  color: #333;
  margin: 0;
}

.other-works .section-header .text-muted {
  color: #999;
  font-size: 14px;
}

.other-works .works-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
}

.other-works .work-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.other-works .work-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
}

.other-works .work-card:hover .work-cover img {
  transform: scale(1.05);
}

.other-works .work-card .work-link {
  text-decoration: none;
  color: inherit;
}

.other-works .work-card .work-cover {
  position: relative;
  padding-top: 66%;
  overflow: hidden;
}

.other-works .work-card .work-cover img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.other-works .work-card .work-cover .work-price {
  position: absolute;
  right: 12px;
  bottom: 12px;
  background: rgba(255, 107, 0, 0.9);
  color: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

.other-works .work-card .work-content {
  padding: 16px;
  width: 100%;
}

.other-works .work-card .work-content .work-title {
  font-size: 15px;
  color: #333;
  margin: 0 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  display: block;
  font-weight: normal;
  line-height: 1.4;
}

.other-works .work-card .work-content .work-meta {
  display: flex;
  gap: 16px;
  color: #999;
  font-size: 13px;
}

.other-works .work-card .work-content .work-meta span {
  display: flex;
  align-items: center;
  gap: 4px;
}

.other-works .work-card .work-content .work-meta span i {
  font-size: 16px;
}

@media screen and (max-width: 768px) {
  .other-works {
    margin: 20px 0;
  }
  
  .other-works .works-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  .other-works .work-card .work-content {
    padding: 12px;
  }
  
  .other-works .work-card .work-content .work-title {
    font-size: 14px;
  }
  
  .other-works .work-card .work-content .work-meta {
    font-size: 12px;
  }
}
@media screen and (max-width: 480px) {
  .banner {
    height: 150px;
  }

  .el-avatar {
    width: 80px !important;
    height: 80px !important;
  }
}

.circles-section {
  margin: 30px 0;

  .section-header {
    display: flex;
    align-items: baseline;
    gap: 12px;
    margin-bottom: 24px;

    h3 {
      font-size: 20px;
      color: #333;
      margin: 0;
    }

    .text-muted {
      color: #999;
      font-size: 14px;
    }
  }

  .circles-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 20px;

    .circle-card {
      background: #fff;
      border-radius: 12px;
      padding: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      text-align: center;
      border: 1px solid #eee;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
      }

      .circle-avatar {
        position: relative;
        margin-bottom: 16px;
        display: inline-block;

        .circle-role {
          position: absolute;
          bottom: -6px;
          left: 50%;
          transform: translateX(-50%);
          background: #ff6b00;
          color: #fff;
          font-size: 12px;
          padding: 2px 10px;
          border-radius: 10px;
          white-space: nowrap;

          &.admin {
            background: #409eff;
          }
        }
      }

      .circle-info {
        .circle-name {
          font-size: 16px;
          color: #333;
          margin: 0 0 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .circle-stats {
          display: flex;
          justify-content: center;
          gap: 16px;
          color: #999;
          font-size: 13px;

          span {
            display: flex;
            align-items: center;
            gap: 4px;

            i {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .circles-section {
    .circles-list {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;

      .circle-card {
        padding: 12px;

        .circle-info {
          .circle-name {
            font-size: 14px;
          }

          .circle-stats {
            font-size: 12px;
            gap: 12px;
          }
        }
      }
    }
  }
}
</style> 